import {
  FDBodyText, FDTitleText,
} from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { ReferralPageInfoBoxes } from 'Views/Page/Content/Templates/ReferralPage/Components/ReferralPageInfoBoxes';
import { ReferralPageDetails } from 'Views/Page/Content/Templates/ReferralPage/Components/ReferralPageDetails';
import { Title } from 'Views/Page/Content/Templates/ReferralPage/Components/Title';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export const getMetaOverrideSet = (isMobile) => buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Title,
  }, overrideReadOnly)
  .nameOverride('body', {
    _component: () => FDBodyText,
    _customProps: {
      align: isMobile ? 'start' : 'center',
    },
  }, overrideReadOnly)
  .nameOverride(['howToTitle', 'detailsTitle'], {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('howToInfo', {
    _component: () => ReferralPageInfoBoxes,
  }, overrideReadOnly)
  .nameOverride('details', {
    _component: () => ReferralPageDetails,
  }, overrideReadOnly)
  .nameOverride(['disclosure', 'attestation', 'termsAndConditions'], {
    _component: () => Richtext,
    _customProps: {
      size: 'sm',
      color: 'textDisabled',
      align: isMobile ? 'start' : 'center',
    },
  }, overrideReadOnly)
  .done();
